module.exports = __webpack_public_path__ + "img/plan-s3.fa1773b1.svg";